export const countries = [
  { value: '', title: 'Select a Country' },
  { value: 'AD', title: 'Andorra' },
  { value: 'AE', title: 'United Arab Emirates' },
  { value: 'AF', title: 'Afghanistan' },
  { value: 'AG', title: 'Antigua and Barbuda' },
  { value: 'AI', title: 'Anguilla' },
  { value: 'AL', title: 'Albania' },
  { value: 'AM', title: 'Armenia' },
  { value: 'AO', title: 'Angola' },
  { value: 'AQ', title: 'Antarctica' },
  { value: 'AR', title: 'Argentina' },
  { value: 'AS', title: 'American Samoa' },
  { value: 'AT', title: 'Austria' },
  { value: 'AU', title: 'Australia' },
  { value: 'AW', title: 'Aruba' },
  { value: 'AX', title: 'Åland Islands' },
  { value: 'AZ', title: 'Azerbaijan' },
  { value: 'BA', title: 'Bosnia and Herzegovina' },
  { value: 'BB', title: 'Barbados' },
  { value: 'BD', title: 'Bangladesh' },
  { value: 'BE', title: 'Belgium' },
  { value: 'BF', title: 'Burkina Faso' },
  { value: 'BG', title: 'Bulgaria' },
  { value: 'BH', title: 'Bahrain' },
  { value: 'BI', title: 'Burundi' },
  { value: 'BJ', title: 'Benin' },
  { value: 'BL', title: 'Saint Barthélemy' },
  { value: 'BM', title: 'Bermuda' },
  { value: 'BN', title: 'Brunei Darussalam' },
  { value: 'BO', title: 'Bolivia (Plurinational State of)' },
  { value: 'BQ', title: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BR', title: 'Brazil' },
  { value: 'BS', title: 'Bahamas' },
  { value: 'BT', title: 'Bhutan' },
  { value: 'BV', title: 'Bouvet Island' },
  { value: 'BW', title: 'Botswana' },
  { value: 'BY', title: 'Belarus' },
  { value: 'BZ', title: 'Belize' },
  { value: 'CA', title: 'Canada' },
  { value: 'CC', title: 'Cocos (Keeling) Islands' },
  { value: 'CD', title: 'Congo, Democratic Republic of the' },
  { value: 'CF', title: 'Central African Republic' },
  { value: 'CG', title: 'Congo' },
  { value: 'CH', title: 'Switzerland' },
  { value: 'CI', title: "Côte d'Ivoire" },
  { value: 'CK', title: 'Cook Islands' },
  { value: 'CL', title: 'Chile' },
  { value: 'CM', title: 'Cameroon' },
  { value: 'CN', title: 'China' },
  { value: 'CO', title: 'Colombia' },
  { value: 'CR', title: 'Costa Rica' },
  { value: 'CU', title: 'Cuba' },
  { value: 'CV', title: 'Cabo Verde' },
  { value: 'CW', title: 'Curaçao' },
  { value: 'CX', title: 'Christmas Island' },
  { value: 'CY', title: 'Cyprus' },
  { value: 'CZ', title: 'Czechia' },
  { value: 'DE', title: 'Germany' },
  { value: 'DJ', title: 'Djibouti' },
  { value: 'DK', title: 'Denmark' },
  { value: 'DM', title: 'Dominica' },
  { value: 'DO', title: 'Dominican Republic' },
  { value: 'DZ', title: 'Algeria' },
  { value: 'EC', title: 'Ecuador' },
  { value: 'EE', title: 'Estonia' },
  { value: 'EG', title: 'Egypt' },
  { value: 'EH', title: 'Western Sahara' },
  { value: 'ER', title: 'Eritrea' },
  { value: 'ES', title: 'Spain' },
  { value: 'ET', title: 'Ethiopia' },
  { value: 'FI', title: 'Finland' },
  { value: 'FJ', title: 'Fiji' },
  { value: 'FK', title: 'Falkland Islands (Malvinas)' },
  { value: 'FM', title: 'Micronesia (Federated States of)' },
  { value: 'FO', title: 'Faroe Islands' },
  { value: 'FR', title: 'France' },
  { value: 'GA', title: 'Gabon' },
  { value: 'GB', title: 'United Kingdom of Great Britain and Northern Ireland' },
  { value: 'GD', title: 'Grenada' },
  { value: 'GE', title: 'Georgia' },
  { value: 'GF', title: 'French Guiana' },
  { value: 'GG', title: 'Guernsey' },
  { value: 'GH', title: 'Ghana' },
  { value: 'GI', title: 'Gibraltar' },
  { value: 'GL', title: 'Greenland' },
  { value: 'GM', title: 'Gambia' },
  { value: 'GN', title: 'Guinea' },
  { value: 'GP', title: 'Guadeloupe' },
  { value: 'GQ', title: 'Equatorial Guinea' },
  { value: 'GR', title: 'Greece' },
  { value: 'GS', title: 'South Georgia and the South Sandwich Islands' },
  { value: 'GT', title: 'Guatemala' },
  { value: 'GU', title: 'Guam' },
  { value: 'GW', title: 'Guinea-Bissau' },
  { value: 'GY', title: 'Guyana' },
  { value: 'HK', title: 'Hong Kong' },
  { value: 'HM', title: 'Heard Island and McDonald Islands' },
  { value: 'HN', title: 'Honduras' },
  { value: 'HR', title: 'Croatia' },
  { value: 'HT', title: 'Haiti' },
  { value: 'HU', title: 'Hungary' },
  { value: 'ID', title: 'Indonesia' },
  { value: 'IE', title: 'Ireland' },
  { value: 'IL', title: 'Israel' },
  { value: 'IM', title: 'Isle of Man' },
  { value: 'IN', title: 'India' },
  { value: 'IO', title: 'British Indian Ocean Territory' },
  { value: 'IQ', title: 'Iraq' },
  { value: 'IR', title: 'Iran (Islamic Republic of)' },
  { value: 'IS', title: 'Iceland' },
  { value: 'IT', title: 'Italy' },
  { value: 'JE', title: 'Jersey' },
  { value: 'JM', title: 'Jamaica' },
  { value: 'JO', title: 'Jordan' },
  { value: 'JP', title: 'Japan' },
  { value: 'KE', title: 'Kenya' },
  { value: 'KG', title: 'Kyrgyzstan' },
  { value: 'KH', title: 'Cambodia' },
  { value: 'KI', title: 'Kiribati' },
  { value: 'KM', title: 'Comoros' },
  { value: 'KN', title: 'Saint Kitts and Nevis' },
  { value: 'KP', title: "Korea (Democratic People's Republic of)" },
  { value: 'KR', title: 'Korea, Republic of' },
  { value: 'KW', title: 'Kuwait' },
  { value: 'KY', title: 'Cayman Islands' },
  { value: 'KZ', title: 'Kazakhstan' },
  { value: 'LA', title: "Lao People's Democratic Republic" },
  { value: 'LB', title: 'Lebanon' },
  { value: 'LC', title: 'Saint Lucia' },
  { value: 'LI', title: 'Liechtenstein' },
  { value: 'LK', title: 'Sri Lanka' },
  { value: 'LR', title: 'Liberia' },
  { value: 'LS', title: 'Lesotho' },
  { value: 'LT', title: 'Lithuania' },
  { value: 'LU', title: 'Luxembourg' },
  { value: 'LV', title: 'Latvia' },
  { value: 'LY', title: 'Libya' },
  { value: 'MA', title: 'Morocco' },
  { value: 'MC', title: 'Monaco' },
  { value: 'MD', title: 'Moldova, Republic of' },
  { value: 'ME', title: 'Montenegro' },
  { value: 'MF', title: 'Saint Martin (French part)' },
  { value: 'MG', title: 'Madagascar' },
  { value: 'MH', title: 'Marshall Islands' },
  { value: 'MK', title: 'Macedonia, the former Yugoslav Republic of' },
  { value: 'ML', title: 'Mali' },
  { value: 'MM', title: 'Myanmar' },
  { value: 'MN', title: 'Mongolia' },
  { value: 'MO', title: 'Macao' },
  { value: 'MP', title: 'Northern Mariana Islands' },
  { value: 'MQ', title: 'Martinique' },
  { value: 'MR', title: 'Mauritania' },
  { value: 'MS', title: 'Montserrat' },
  { value: 'MT', title: 'Malta' },
  { value: 'MU', title: 'Mauritius' },
  { value: 'MV', title: 'Maldives' },
  { value: 'MW', title: 'Malawi' },
  { value: 'MX', title: 'Mexico' },
  { value: 'MY', title: 'Malaysia' },
  { value: 'MZ', title: 'Mozambique' },
  { value: 'NA', title: 'Namibia' },
  { value: 'NC', title: 'New Caledonia' },
  { value: 'NE', title: 'Niger' },
  { value: 'NF', title: 'Norfolk Island' },
  { value: 'NG', title: 'Nigeria' },
  { value: 'NI', title: 'Nicaragua' },
  { value: 'NL', title: 'Netherlands' },
  { value: 'NO', title: 'Norway' },
  { value: 'NP', title: 'Nepal' },
  { value: 'NR', title: 'Nauru' },
  { value: 'NU', title: 'Niue' },
  { value: 'NZ', title: 'New Zealand' },
  { value: 'OM', title: 'Oman' },
  { value: 'PA', title: 'Panama' },
  { value: 'PE', title: 'Peru' },
  { value: 'PF', title: 'French Polynesia' },
  { value: 'PG', title: 'Papua New Guinea' },
  { value: 'PH', title: 'Philippines' },
  { value: 'PK', title: 'Pakistan' },
  { value: 'PL', title: 'Poland' },
  { value: 'PM', title: 'Saint Pierre and Miquelon' },
  { value: 'PN', title: 'Pitcairn' },
  { value: 'PR', title: 'Puerto Rico' },
  { value: 'PS', title: 'Palestine, State of' },
  { value: 'PT', title: 'Portugal' },
  { value: 'PW', title: 'Palau' },
  { value: 'PY', title: 'Paraguay' },
  { value: 'QA', title: 'Qatar' },
  { value: 'RE', title: 'Réunion' },
  { value: 'RO', title: 'Romania' },
  { value: 'RS', title: 'Serbia' },
  { value: 'RU', title: 'Russian Federation' },
  { value: 'RW', title: 'Rwanda' },
  { value: 'SA', title: 'Saudi Arabia' },
  { value: 'SB', title: 'Solomon Islands' },
  { value: 'SC', title: 'Seychelles' },
  { value: 'SD', title: 'Sudan' },
  { value: 'SE', title: 'Sweden' },
  { value: 'SG', title: 'Singapore' },
  { value: 'SH', title: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'SI', title: 'Slovenia' },
  { value: 'SJ', title: 'Svalbard and Jan Mayen' },
  { value: 'SK', title: 'Slovakia' },
  { value: 'SL', title: 'Sierra Leone' },
  { value: 'SM', title: 'San Marino' },
  { value: 'SN', title: 'Senegal' },
  { value: 'SO', title: 'Somalia' },
  { value: 'SR', title: 'Suriname' },
  { value: 'SS', title: 'South Sudan' },
  { value: 'ST', title: 'Sao Tome and Principe' },
  { value: 'SV', title: 'El Salvador' },
  { value: 'SX', title: 'Sint Maarten (Dutch part)' },
  { value: 'SY', title: 'Syrian Arab Republic' },
  { value: 'SZ', title: 'Eswatini' },
  { value: 'TC', title: 'Turks and Caicos Islands' },
  { value: 'TD', title: 'Chad' },
  { value: 'TF', title: 'French Southern Territories' },
  { value: 'TG', title: 'Togo' },
  { value: 'TH', title: 'Thailand' },
  { value: 'TJ', title: 'Tajikistan' },
  { value: 'TK', title: 'Tokelau' },
  { value: 'TL', title: 'Timor-Leste' },
  { value: 'TM', title: 'Turkmenistan' },
  { value: 'TN', title: 'Tunisia' },
  { value: 'TO', title: 'Tonga' },
  { value: 'TR', title: 'Turkey' },
  { value: 'TT', title: 'Trinidad and Tobago' },
  { value: 'TV', title: 'Tuvalu' },
  { value: 'TW', title: 'Taiwan, Province of China' },
  { value: 'TZ', title: 'Tanzania, United Republic of' },
  { value: 'UA', title: 'Ukraine' },
  { value: 'UG', title: 'Uganda' },
  { value: 'UM', title: 'United States Minor Outlying Islands' },
  { value: 'US', title: 'United States of America' },
  { value: 'UY', title: 'Uruguay' },
  { value: 'UZ', title: 'Uzbekistan' },
  { value: 'VA', title: 'Holy See' },
  { value: 'VC', title: 'Saint Vincent and the Grenadines' },
  { value: 'VE', title: 'Venezuela (Bolivarian Republic of)' },
  { value: 'VG', title: 'Virgin Islands (British)' },
  { value: 'VI', title: 'Virgin Islands (U.S.)' },
  { value: 'VN', title: 'Viet Nam' },
  { value: 'VU', title: 'Vanuatu' },
  { value: 'WF', title: 'Wallis and Futuna' },
  { value: 'WS', title: 'Samoa' },
  { value: 'YE', title: 'Yemen' },
  { value: 'YT', title: 'Mayotte' },
  { value: 'ZA', title: 'South Africa' },
  { value: 'ZM', title: 'Zambia' },
  { value: 'ZW', title: 'Zimbabwe' }
];
